import { Injectable, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Injectable()
export class PageStateService implements OnDestroy {
  public isRefreshing: boolean;
  private readonly subscriptions = new Subscription();
  private readonly boundOnBeforeUnload: () => void;

  constructor(private readonly tokenStorage: TokenStorageService) {
    this.boundOnBeforeUnload = this.onBeforeUnload.bind(this);
    window.addEventListener('beforeunload', this.boundOnBeforeUnload);
  }

  private onBeforeUnload(): void {
    this.isRefreshing = true;

    this.subscriptions.add(timer(3000).subscribe(() => (this.isRefreshing = false)));

    if (
      this.tokenStorage.userInfo &&
      this.tokenStorage.userInfo.IsPasswordInitial &&
      !this.tokenStorage.userInfo.CurrentSite.PowerSuitEidAuthEnabled
    ) {
      this.tokenStorage.clearStorageData();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.boundOnBeforeUnload);
    this.subscriptions.unsubscribe();
  }
}
